import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import phone from "../../Assests/phone.svg";
import FbIcon from '../../Assests/Facebook Icon.svg';
import InstaIcon from '../../Assests/Instagram Icon.svg';
import emailjs from 'emailjs-com';
import contactImg from "../../Assests/contact.jpg";

function Contact() {
  const location = useLocation();
  const interest = new URLSearchParams(location.search).get('interest');
  const startingMessage = interest === 'natyafusion'
    ? "Hi! I'm interested in joining NatyaFusion and performing at the Houston Rockets pregame show. "
    : '';
  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', message: startingMessage,
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const serviceID = "service_7rm4pph";
    const templateID = "template_d0syfvg";
    const publicKey = "aGkt90wix3DEkpHFU";
    const contactPhone = formData.phone || 'Not provided';
    const contactEmail = formData.email || 'Not provided';
    const templateParams = {
      name: formData.name,
      from_name: formData.name,
      phone: contactPhone,
      phone_number: contactPhone,
      email: contactEmail,
      from_email: contactEmail,
      user_email: contactEmail,
      reply_to: formData.email,
      message: formData.message,
    };
    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log("Email sent successfully!", response);
        alert("Your message has been sent successfully!");
        setFormData({ name: '', phone: '', email: '', message: '' });
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        alert("Failed to send the message. Please try again later.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className='bg-white md:px-[192px] px-4 py-20'>

      {/* Section Header */}
      <div className='text-center mb-14'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>We'd Love to Hear From You</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: 'Playfair Display, serif' }}>
  Contact <em style={{ color: '#E40F94' }}>Us</em>
</h1>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      <div className='flex flex-col md:flex-row gap-12 items-start'>

        {/* Left — Contact Image & Info */}
        <div className='md:w-1/2 w-full'>
          <div className='group relative overflow-hidden rounded-2xl shadow-xl'>
            <img src={contactImg} className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-105' alt="Contact" />
            <div className='absolute inset-0 bg-black bg-opacity-40 rounded-2xl'></div>
            <div className='absolute bottom-0 left-0 right-0 p-8'>
              <p className='text-[13px] uppercase tracking-[4px] text-[#E40F94] font-semibold mb-4'>Get In Touch</p>
              <div className='flex items-center gap-3 mb-3'>
                <img src={phone} className='w-5 h-5' alt="Phone" />
                <p className='text-white text-[16px] font-medium'>(469) 556-3040</p>
              </div>
              <div className='flex items-center gap-3 mb-3'>
                <img src={FbIcon} className='w-5 h-5' alt="Facebook" />
                <p className='text-white text-[16px] font-medium'>Chilanka Dance School</p>
              </div>
              <div className='flex items-center gap-3'>
                <img src={InstaIcon} className='w-5 h-5' alt="Instagram" />
                <p className='text-white text-[16px] font-medium'>@chilankadanceschool</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right — Contact Form */}
        <div className='md:w-1/2 w-full'>
          <div className='bg-gray-50 rounded-2xl p-8 shadow-md'>
            <p className='text-[13px] uppercase tracking-[4px] text-[#E40F94] font-semibold mb-2'>Send Us a Message</p>
            <h2 className='text-[28px] font-bold text-gray-900 mb-2' style={{ fontFamily: 'Playfair Display, serif' }}>
  Let's <em style={{ color: '#E40F94' }}>Connect</em>
</h2>
            <div className='w-10 h-[3px] bg-[#E40F94] rounded-full mb-8'></div>
            <form className='space-y-5' onSubmit={handleSubmit}>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                <div>
                  <label className='block text-[13px] font-medium text-gray-700 mb-1'>Name</label>
                  <input type="text" name='name' required value={formData.name} onChange={handleChange} placeholder="Your name" className='w-full p-3 mt-1 rounded-xl bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E40F94] text-[15px]' />
                </div>
                <div>
                  <label className='block text-[13px] font-medium text-gray-700 mb-1'>Phone Number</label>
                  <input type="tel" name='phone' value={formData.phone} onChange={handleChange} placeholder="Your phone number" className='w-full p-3 mt-1 rounded-xl bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E40F94] text-[15px]' />
                </div>
              </div>
              <div>
                <label className='block text-[13px] font-medium text-gray-700 mb-1'>Email</label>
                <input type="email" name='email' required value={formData.email} onChange={handleChange} placeholder="Your email address" className='w-full p-3 mt-1 rounded-xl bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E40F94] text-[15px]' />
              </div>
              <div>
                <label className='block text-[13px] font-medium text-gray-700 mb-1'>Message</label>
                <textarea name='message' value={formData.message} onChange={handleChange} placeholder="How can we help you?" rows="5" className='w-full p-3 mt-1 rounded-xl bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E40F94] text-[15px]' />
              </div>
              <button type="submit" className='w-full bg-[#E40F94] text-white py-4 rounded-full text-[16px] font-bold hover:bg-[#c00c7b] transition-colors duration-300 shadow-lg'>
                {isLoading ? 'Sending...' : 'Send Message →'}
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Contact;
